import React from 'react';

/**
 * No data state component for signage
 * @param {Object} props - Component props
 * @param {React.RefObject} props.containerRef - Container reference
 * @param {Object} props.signageDesign - Signage design object
 * @param {string} props.screenId - Screen ID
 * @returns {JSX.Element} No data state component
 */
const NoDataState = ({ containerRef, signageDesign, screenId }) => (
  <div className='signage row panels panels-horizontal' style={{ margin: "0px" }}>
    <div ref={containerRef} style={{ 
      height: "100vh", 
      width: "100%", 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center" 
    }}>
      <div style={{ 
        textAlign: 'center',
        padding: "24px",
        border: "2px dashed #6c757d",
        borderRadius: "8px",
        backgroundColor: "#f8f9fa"
      }}>
        <h3 style={{ margin: "0 0 12px 0", color: "#6c757d" }}>No Layout Components</h3>
        <p style={{ margin: "0 0 16px 0", color: "#6c757d" }}>
          No components found in design data
        </p>
        <div style={{ fontSize: "14px", color: "#6c757d" }}>
          Design: {signageDesign ? "✅ Loaded" : "❌ No Data"} | 
          Components: {signageDesign?.getComponentCount() || 0} |
          Screen ID: {screenId}
        </div>
      </div>
    </div>
  </div>
);

export default NoDataState;
